interface Location {
  current_longitude: number
  current_latitude: number
  [key: string]: any // Allows for dynamic properties
}

export interface GeoJSONFeature<T = any> {
  type: 'Feature'
  geometry: {
    type: 'Point'
    coordinates: [number, number]
  }
  properties: T
}

interface GeoJSON<T = any> {
  type: 'FeatureCollection'
  features: GeoJSONFeature<T>[]
}

/**
 * Converts location data into GeoJSON format
 * @param {Array<Location>} locations - Array of location data
 * @param {Function} getProperties - Function to extract properties for each location
 * @returns {GeoJSON} GeoJSON formatted data
 */
export const toGeoJSON = <T = any>(
  locations: Location[],
  getProperties: (location: Location) => T
): GeoJSON<T> => ({
  type: 'FeatureCollection',
  features: locations.map((loc) => ({
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [loc.current_longitude, loc.current_latitude],
    },
    properties: getProperties(loc),
  })),
})
